import { render, staticRenderFns } from "./ClientViewSidebarCommercialist.vue?vue&type=template&id=68fa4366&scoped=true"
import script from "./ClientViewSidebarCommercialist.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarCommercialist.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarCommercialist.vue?vue&type=style&index=0&id=68fa4366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa4366",
  null
  
)

export default component.exports